<ixfi-header [isLoggedIn]="isLoggedIn" (logoutEvent)="onLogout()"></ixfi-header>
<router-outlet (activate)="onActivate()"></router-outlet>
<ixfi-footer (subscribeEvent)="onSubscribe($event)" [isLoggedIn]="isLoggedIn"></ixfi-footer>
